import {
  savePermissionSetsForUsersPayloadType,
  TableFilterApiBody,
} from '../types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const getPermissionAssignmentList = async (payload: {
  page: number
  size: number
  sort?: string
  filter: TableFilterApiBody | undefined
}) => {
  return await axiosInstance.post(
    `${
      API_END_POINT.CORE
    }permission-set/listUserPrograms/advance?sort=enabled,DESC&page=${
      payload.page - 1
    }&size=${payload.size}`,
    payload.filter,
    {
      params: {
        sort: payload.sort,
      },
    }
  )
}

export const getPermissionAssignmentListForGlobal = async (payload: {
  page: number
  size: number
  sort?: string
  filter: TableFilterApiBody | undefined
}) => {
  return await axiosInstance.post(
    `${
      API_END_POINT.CORE
    }permission-set/listUserGlobalPermissions/advance?sort=enabled,DESC&page=${
      payload.page - 1
    }&size=${payload.size}`,
    payload.filter,
    {
      headers: {
        'X-TenantId': '',
      },
      params: {
        sort: payload.sort,
      },
    }
  )
}

export const getProgramsAndPermissionSets = async (payload: { id: string }) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}permission-set/programWithPermissionSets/${payload.id}`
  )
}

export const getPermissionSetsForGlobal = async (payload: { id: string }) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}permission-set/fetchGlobalPermissionSets/${payload.id}`,
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}

export const getPermissionSetsList = () => {
  return axiosInstance.get(`${API_END_POINT.CORE}permission-set/all`)
}

export const savePermissionSetsForUsers = (
  payload: savePermissionSetsForUsersPayloadType
) => {
  return axiosInstance.put(`${API_END_POINT.CORE}permission-set/users`, payload)
}

export const saveGlobalPermissionSetsForUsers = (
  payload: savePermissionSetsForUsersPayloadType
) => {
  return axiosInstance.put(
    `${API_END_POINT.CORE}permission-set/global/users`,
    payload,
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}

export const togglePermissionAssignment = (payload: {
  id: number | string
  enabled: boolean
  isGlobal: boolean
}) => {
  return axiosInstance.patch(
    `${API_END_POINT.CORE}permission-set/disable/${payload.id}?enabled=${payload.enabled}`,
    {},
    payload.isGlobal
      ? {
          headers: {
            'X-TenantId': '',
          },
        }
      : {}
  )
}

export const getUnassignedUsers = async (
  payload: string[],
  sendClientId = true
) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}users/fetchUnassignedUsers?isConfig=${!sendClientId}`,
    { programs: payload.length > 0 ? payload : undefined }
  )
}

export const getUnassignedUsersForGlobal = async (payload: boolean) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}users/unassignedGlobalUsers`,
    { assigning_global_permission_set: payload },
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}
